import React, { Suspense } from "react";
import { Link, Switch, Route } from "wouter";
import { Header } from "./components/Header";
import Detail from "./pages/Detail";
import SearchResults from "./pages/SearchResults";
import Accounts from "./pages/Accounts";
import { KatiContextProvider } from "./context/kati";
import "./App.css";
import packageInfo from "../package.json";

const HomePage = React.lazy(() => import("./pages/Home"));

export const App = () => (
  <div className="App">
    <Suspense fallback={null}>
      <section className="App-content">
        <KatiContextProvider>
          <Header>
            <div>
              <Link to="/">
                <h1>KATI</h1>
              </Link>
              <span>{packageInfo.version}</span>
            </div>
          </Header>
          <main>
            <Switch>
              <Route component={HomePage} path="/" />
              <Route component={Detail} path="/book/:id" />
              <Route
                component={SearchResults}
                path="/search/:keyword/:category"
              />
              <Route component={Accounts} path="/login" />
            </Switch>
          </main>
        </KatiContextProvider>
      </section>
    </Suspense>
  </div>
);
